import { handleResponse, handleError, authHeader } from "./apiUtils";
import axios from "axios";
import { API_ROOT } from "./api-config";

const base = API_ROOT + "uom/";

export function getUOM() {
  return axios({
    method: "GET",
    url: base + "GetUOM",
    headers: authHeader()
  })
    .then(handleResponse)
    .catch(handleError);
}
